import { useModal } from '@ebay/nice-modal-react';
import { createContext, PropsWithChildren, useCallback, useState } from 'react';

import { SetState } from 'utils/types';

import { CreateWorkspaceInitOptions, CreateWorkspaceMode, CreateWorkspaceStepsEnum } from '../types';

export type CreateWorkspaceDataContextType = {
  currentStep: CreateWorkspaceStepsEnum;
  setCurrentStep: SetState<CreateWorkspaceStepsEnum>;
  removeModal: () => void;
  wasInviteStepSkipped: boolean;
  setWasInviteStepSkipped: SetState<boolean>;
  createdWorkspaceId: string | null;
  setCreatedWorkspaceId: SetState<string | null>;
  invitees: string[];
  setInvitees: SetState<string[]>;
} & Pick<CreateWorkspaceInitOptions, 'parentWorkspaceId' | 'mode'>;

export const CreateWorkspaceDataContext = createContext<CreateWorkspaceDataContextType | null>(null);

const CreateWorkspaceDataProvider = ({
  children,
  parentWorkspaceId,
  initialStep = CreateWorkspaceStepsEnum.CREATE,
  initialWorkspaceId = null,
  mode = CreateWorkspaceMode.FULL,
}: PropsWithChildren<CreateWorkspaceInitOptions>) => {
  const { remove } = useModal();
  const [invitees, setInvitees] = useState<string[]>([]);
  const [currentStep, setCurrentStep] = useState(initialStep);
  const [wasInviteStepSkipped, setWasInviteStepSkipped] = useState(false);
  const [createdWorkspaceId, setCreatedWorkspaceId] = useState<string | null>(initialWorkspaceId);

  const removeModal = useCallback(remove, [remove]);

  return (
    <CreateWorkspaceDataContext.Provider
      value={{
        currentStep,
        setCurrentStep,
        removeModal,
        wasInviteStepSkipped,
        setWasInviteStepSkipped,
        createdWorkspaceId,
        setCreatedWorkspaceId,
        invitees,
        setInvitees,
        parentWorkspaceId,
        mode,
      }}
    >
      {children}
    </CreateWorkspaceDataContext.Provider>
  );
};

export default CreateWorkspaceDataProvider;
